import axios from 'axios';
import { TOKEN_REFRESH_THRESHOLD_MINUTES } from '../constants/app.constants'; 
import { clearAuthSession, getLastTokenUpdate, updateLastTokenUpdate } from './auth'; 
import { getAppUrlInfo } from './urls';

/**
 * Checks if the token should be refreshed based on local time,
 * and calls the /auth/refresh endpoint if needed.
 */
export const checkAndRefreshTokenIfNeeded = async (): Promise<void> => {
  const lastTokenUpdate = getLastTokenUpdate();
  const { accountsApiUrl, accountsUrl } = getAppUrlInfo(); 
  // ✅ Not logged in — skip
  if (!lastTokenUpdate) return;
  const now = Date.now();
  const diffMinutes = (now - lastTokenUpdate) / (1000 * 60);

  if (diffMinutes > TOKEN_REFRESH_THRESHOLD_MINUTES) {
    try {
      await axios({
        method: 'get',
        // url: ACCOUNTS_API_PATHS.refreshToken, 
        url: `${accountsApiUrl}/auth/refresh`,
        withCredentials: true,
      });

      updateLastTokenUpdate();
      console.log('[AUTH] Token refreshed at', new Date().toLocaleTimeString());
    } catch (err: any) {
      console.warn('[AUTH] Token refresh failed:', err);
      //if (err?.response?.status === 401) {
        clearAuthSession(); // ✅ clear cookies
        window.location.href = accountsUrl; // ✅ Hard redirect to force logout
      //}
    }
  }
};
